//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PhotoJewelryCropper from '@/frontend/components/common/photo-jewelry-cropper'

export default {
  name: "photo-jewelry",
  components: {
    PhotoJewelryCropper
  },
  props: {
    control: {required: true},
    data: {required: true},
    product: {required: true},
    stonePositions: {required: true},
  },
  data() {
    return {
      imageCropper: false,
      tmpImageUrl: ''
    }
  },
  methods: {
    async imageCropped(img) {
      const formData = new FormData()
      formData.append('file', img.blob, img.filename)
      formData.append('title', img.title)
      formData.append('targetCode', "PHOTO_JEWELRY")

      this.tmpImageUrl = ''
      
      const uploadResponse = await this.$axios.$post(
          '/upload/tmp-file',
          formData
      ).catch(error => {
        if (error.response && error.response.status === 400) {
          console.log(error.response)
          this.$toast.error(error.response.data.errorMessage)
        }
        this.imageCropper = false
      })
      
      if (uploadResponse) {
        this.tmpImageUrl = uploadResponse.tmpFileUrl.replace("#", '%23')
        this.imageCropper = false
        this.$emit('updateValue', {
          controlType: this.control.type,
          controlName: this.control.name,
          value: this.tmpImageUrl,
        })
      }
    },
    closeImageCropper() {
      this.imageCropper = false
    },
    handleFileUpload(ref) {
      const file = ref.files[0]
      if (file.type.includes('image/')) {
        this.imageCropper = true
        this.$nextTick(() => {
          this.$refs.imageCropper.setImageToCrop(file)
        })
      }
    }
  }
}
